import { render, staticRenderFns } from "./AddAttachmentToSectionDialog.vue?vue&type=template&id=4234ca0c"
import script from "./AddAttachmentToSectionDialog.vue?vue&type=script&lang=js"
export * from "./AddAttachmentToSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports